import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import useStyles from '../index.style';
import PropTypes from 'prop-types';
import { Add } from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router';

const DownloadItemHeader = () => {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const movieId = params.get('movie');

  return (
    <Box className={classes.inBuildAppHeader}>
      <Box className={classes.inBuildAppHeaderSidebar}>
        <Typography className={classes.inBuildAppHeaderTitle} component="div" variant="h1">
          جدول روابط
        </Typography>
      </Box>

      <Box className={classes.inBuildAppHeaderContent}>
        <Box ml="auto" display="flex" alignItems="center">
          <Box ml={1}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => history.push(`/create-relation/?movie=${movieId}`)}
              endIcon={<Add />}>
              افزودن رابطه
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DownloadItemHeader;

DownloadItemHeader.prototype = {
  onChangeViewMode: PropTypes.func,
};
